import React, {
 useCallback,
 useEffect,
 useMemo,
 useState,
 Suspense,
} from "react";
import {
 deleteItem,
 fetchData,
 toggleStatus,
} from "../../../utils/apiUtils";
import {  PlusButton } from "../../../helper/ImageFormat";
import DeleteModel from "../../../Components/DeleteModel";
import Breadcrumb from "../../../helper/Breadcrumb";
import HandlerTable from "./HandlerTable";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import { useNavigate } from "react-router-dom";

const Handler = () => {
  const navigator = useNavigate();
 const [loading, setLoading] = useState(true);
 const [currencies, setCurrencies] = useState([]);
 const [search, setSearch] = useState("");
 const [deleteItemId, setDeleteItemId] = useState(null);
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10)
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [isDeleting, setIsDeleting] = useState(false);
 const totalPages = useMemo(
  () => Math.ceil(totalCount / perPage),
  [totalCount, perPage]
 );

 const fetchUserData = useCallback(
  async (page = 1, searchQuery = "") => {
   setLoading(true);
   await fetchData(
    "handler-pagination",
    { perPage, pageNo: page, search: searchQuery },
    setCurrencies,
    setTotalCount,
    setCurrentPage,
    setLoading
   );
  },
  [perPage]
 );



 useEffect(() => {
  const delay = search ? 500 : 0;
  const handler = setTimeout(() => {
   fetchUserData(1, search);
  }, delay);

  return () => clearTimeout(handler);
 }, [search, perPage]);



 const handleDelete = async (data) => {
  setDeleteItemId(data.id);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("handler", deleteItemId, fetchUserData,[]);
   setDeleteItemId(null);
   setDeleteModalOpen(false);
   return res;
  } catch (err) {
   throw err;
  } finally {
   setIsDeleting(false);
  }
 };

 const handleStatusToggle = async (handler) => {
  const data = await toggleStatus(
   "handler-status",
   handler?.id,
   fetchUserData
  );
  if (Object.keys(data).length > 0) {
   setCurrencies((prevdata) =>
    prevdata.map((curr) =>
     curr.id === handler.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchUserData(page);
  }
 };
 

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Users", path: "*" },
 ];

 

 
 const handleAdd = () => {
  navigator("/add-user");
 };

 const handleEditClick = (item) => {
  navigator("/add-user", {
   state: item,
  });
 };
 return (
  <>
   <div className="content-wrapper">
    <div
     className="page-header mt-5"
     style={{ display: "flex", justifyContent: "space-between" }}
    >
     <h3 className="custom-page-title">Users</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
      <PerPageSelect value={perPage} onChange={setPerPage}/>

     <div style={{ display: "flex", gap: "20px" }}>
     <TableSearch value={search} onChange={setSearch} />
      <PlusButton handleAdd={handleAdd} module={"Users"} />
     
     </div>
    </div>

    <HandlerTable
     loading={loading}
     currencies={currencies}
     currentPage={currentPage}
     perPage={perPage}
     totalPages={totalPages}
     totalCount={totalCount}
     handlePageClick={handlePageClick}
     handleEditClick={handleEditClick}
     handleDelete={handleDelete}
     handleStatusToggle={handleStatusToggle}
    />
   </div>

   
   <Suspense fallback={<div>Loading...</div>}>
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="Users"
     isDeleting={isDeleting}
    />
   </Suspense>
  </>
 );
};

export default Handler;
